module.exports = {
      id: "prothomalo-com-usage",
      viewBox: "0 0 200 27",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#prothomalo-com",
      toString: function () {
        return this.url;
      }
    }